import React, { useState } from "react";
import LeadTable from "./LeadTable";

// const VIEW_HINTS = {
//   active: "View all leads that are active.",
//   lost: "View all leads that have been lost.",
//   calendar: "A 30-day calendar view of leads.",
// };

const Leads: React.FC = () => {
  const [view, setView] = useState<"active" | "lost">("active");
  // const [viewHint, setViewHint] = useState<string>(VIEW_HINTS.active);

  return (
    <div className="px-8 py-4 w-full flex flex-col gap-0.5">
      <div className="flex flex-col gap-4">
        <div className="space-y-0.5">
          <h1 className="text-2xl font-bold">Leads</h1>
          {/* <h2 className="text-sm text-stone-700">
            All your leads, in one place.
          </h2> */}
        </div>
        <div>
          <div className="flex items-center gap-4 text-sm">
            <button
              disabled={view === "active"}
              // onMouseEnter={() => setViewHint(VIEW_HINTS.active)}
              // onMouseLeave={() => setViewHint(VIEW_HINTS[view])}
              onClick={() => setView("active")}
              className={`py-0.5 pl-0 px-2 flex items-center gap-1 ${
                view === "active"
                  ? "underline underline-offset-4 decoration-black font-bold decoration-2"
                  : "text-stone-600 decoration-stone-300"
              }`}
            >
              Active Leads
            </button>
            {/* <Separator orientation="vertical" className="h-4 bg-stone-600" /> */}
            <button
              disabled={view === "lost"}
              // onMouseEnter={() => setViewHint(VIEW_HINTS.lost)}
              // onMouseLeave={() => setViewHint(VIEW_HINTS[view])}
              onClick={() => setView("lost")}
              className={`py-0.5 px-2 flex items-center gap-1 ${
                view === "lost"
                  ? "underline underline-offset-4 decoration-black font-bold decoration-2"
                  : "text-stone-600 decoration-stone-300"
              }`}
            >
              Lost Leads
            </button>
          </div>
          {/* <div className="text-sm text-stone-800 justify-self-end">
            {viewHint}
          </div> */}
        </div>
      </div>

      {/* <div className="w-full flex flex-row justify-center items-center">
          <div className="flex items-center space-x-4">
            <button
              disabled={view === "calendar"}
              onMouseEnter={() => setViewHint(VIEW_HINTS.calendar)}
              onMouseLeave={() => setViewHint(VIEW_HINTS[view])}
              onClick={() => setView("calendar")}
              className={`py-2 rounded flex items-center gap-1 ${
                view === "calendar"
                  ? "text-stone-900 font-bold underline underline-offset-4"
                  : "text-stone-600 hover:underline hover:underline-offset-4 decoration-stone-300"
              }`}
            >
              <Calendar className="w-4 h-4" />
              Calendar View
            </button>
            <button
              onClick={() => navigate("/leads")}
              className={`py-2 rounded ${
                activeTab === "active"
                  ? "text-stone-900 font-bold underline underline-offset-4"
                  : "text-stone-600 hover:underline hover:underline-offset-4 decoration-stone-300"
              }`}
            >
              Leads
            </button>
            <Separator orientation="vertical" className="h-4 bg-stone-600" />
            <button
              onClick={() => navigate("/leads/calendar")}
              className={`py-2 rounded ${
                activeTab === "calendar"
                  ? "text-stone-900 font-bold underline underline-offset-4"
                  : "text-stone-600 hover:underline hover:underline-offset-4 decoration-stone-300"
              }`}
            >
              Calendar View
            </button>
          </div>
          <div>
            <button
              onClick={() => navigate("/leads/lost")}
              className={`py-2 rounded ${
                activeTab === "lost"
                  ? "text-stone-900 font-bold underline underline-offset-4"
                  : "text-stone-600"
              }`}
            >
              Lost
            </button>
          </div>
        </div> */}
      <div>
        {view === "active" ? (
          <LeadTable view="active" />
        ) : (
          <LeadTable view="lost" />
        )}
      </div>
    </div>
  );
};

export default Leads;
